(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mo-contact-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('mo-contact-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    let opener;
    const open = (source) => {
      opener = source || document.activeElement;
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('mo-contact-is-open');
      const target = dialog.querySelector('[data-mo-contact-result]') || dialog.querySelector('#mo-contact-name');
      target?.focus();
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-mo-contact-open]');
      if (!trigger) return;
      event.preventDefault();
      open(trigger);
    });
    dialog.querySelector('[data-mo-contact-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('mo-contact-is-open');
      opener?.focus();
    });
    if ((window.location.hash === '#MoContactForm' || new URLSearchParams(window.location.search).has('contact_posted')) && dialog.querySelector('[data-mo-contact-result]')) open();
  })();
  } catch(e) { console.error(e); }
})();

})();
